const firebaseConfig = {
  apiKey: "AIzaSyCQpkMY0OSW0BZPVWaY-_QxeE94MhWhAAU",
  authDomain: "travel-guru-outing.firebaseapp.com",
  databaseURL: "https://travel-guru-outing.firebaseio.com",
  projectId: "travel-guru-outing",
  storageBucket: "travel-guru-outing.appspot.com",
  messagingSenderId: "575373653661",
  appId: "1:575373653661:web:557a44f7a9375355a08674"
};
  export default firebaseConfig;

  